import { render, staticRenderFns } from "./ModifyResourceOnUserMove.vue?vue&type=template&id=763f54a2"
import script from "./ModifyResourceOnUserMove.vue?vue&type=script&lang=js"
export * from "./ModifyResourceOnUserMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports